var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5H17.5",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 9.1665H17.5",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 15.5797H2.5M17.5 15.5797V4.56522C17.5 4.01749 17.2795 3.49219 16.887 3.10489C16.4944 2.71758 15.9621 2.5 15.407 2.5H4.59302C4.03792 2.5 3.50555 2.71758 3.11303 3.10489C2.72051 3.49219 2.5 4.01749 2.5 4.56522V15.5797M17.5 15.5797V17.6449C17.5 17.8275 17.4265 18.0026 17.2957 18.1317C17.1648 18.2608 16.9874 18.3333 16.8023 18.3333H14.7093C14.5243 18.3333 14.3468 18.2608 14.216 18.1317C14.0851 18.0026 14.0116 17.8275 14.0116 17.6449V15.5797M2.5 15.5797V17.6449C2.5 17.8275 2.5735 18.0026 2.70434 18.1317C2.83518 18.2608 3.01264 18.3333 3.19767 18.3333H5.2907C5.47573 18.3333 5.65319 18.2608 5.78403 18.1317C5.91487 18.0026 5.98837 17.8275 5.98837 17.6449V15.5797",
    stroke: "#969696",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 13.3332C13.7936 13.3332 14.1667 12.9601 14.1667 12.4998C14.1667 12.0396 13.7936 11.6665 13.3333 11.6665C12.8731 11.6665 12.5 12.0396 12.5 12.4998C12.5 12.9601 12.8731 13.3332 13.3333 13.3332Z",
    fill: "#969696"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66634 13.3332C7.12658 13.3332 7.49967 12.9601 7.49967 12.4998C7.49967 12.0396 7.12658 11.6665 6.66634 11.6665C6.2061 11.6665 5.83301 12.0396 5.83301 12.4998C5.83301 12.9601 6.2061 13.3332 6.66634 13.3332Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBus);
export default __webpack_public_path__ + "static/media/bus.81f02cd0d70a7b3f1879915931a95f55.svg";
export { ForwardRef as ReactComponent };